// eslint-disable-next-line import/no-mutable-exports
export let navigator;

export const setTopLevelNavigation = (ref) => {
  navigator = ref;
};
